import { render, staticRenderFns } from "./viewPromotedApps.vue?vue&type=template&id=a5b4a176&scoped=true"
import script from "./viewPromotedApps.vue?vue&type=script&lang=js"
export * from "./viewPromotedApps.vue?vue&type=script&lang=js"
import style0 from "./viewPromotedApps.vue?vue&type=style&index=0&id=a5b4a176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b4a176",
  null
  
)

export default component.exports